// extracted by mini-css-extract-plugin
module.exports = {"bgHome":"theme_bgHome__2SC6j","bgNotes":"theme_bgNotes__2TBks","bgCounter":"theme_bgCounter__iwkdU","bgProfile":"theme_bgProfile__1OJVl"};